import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Dialog, DialogContent, IconButton } from '@mui/material';

export function FullImageDialog({ open, src, alt, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogContent sx={{ position: 'relative', p: 0, bgcolor: 'black' }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'white',
            zIndex: 2,
            background: 'rgba(0,0,0,0.4)',
            '&:hover': { background: 'rgba(0,0,0,0.7)' },
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={src}
            alt={alt}
            style={{
              maxWidth: '100%',
              maxHeight: '80vh',
              objectFit: 'contain',
              display: 'block',
              margin: '0 auto',
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
